import {AppUrls} from 'shared/config/model/urls';

import {getMonitorLifecycleTexts, useMonitorDelete, useMonitorPause, useMonitorResume} from 'entities/monitor';
import {domainIncidentAPI} from 'features/domain/api/domainIncidentAPI';
import {domainMonitorAPI} from 'features/domain/api/domainMonitorAPI';
import {TypedDispatch} from 'shared/model/types';

import IDomainMonitorOutput from './DomainMonitor/IDomainMonitor';

interface IMutationParams {
    item: Pick<IDomainMonitorOutput, 'uuid'>,
    handleClose: () => void,
}

export const useDomainMonitorPause = ({item, handleClose}: IMutationParams) => {
    const [updateDomainMonitor, {isLoading}] = domainMonitorAPI.useUpdateDomainMonitorMutation();

    return useMonitorPause({
        request: () => updateDomainMonitor({uuid: item.uuid, active: false}).unwrap(),
        isLoading,
        handleClose,
        successText: getMonitorLifecycleTexts().paused,
    });
};

export const useDomainMonitorResume = ({item, handleClose}: IMutationParams) => {
    const [updateDomainMonitor, {isLoading}] = domainMonitorAPI.useUpdateDomainMonitorMutation();

    return useMonitorResume({
        request: () => updateDomainMonitor({uuid: item.uuid, active: true}).unwrap(),
        isLoading,
        handleClose,
        successText: getMonitorLifecycleTexts().resumed,
    });
};

const invalidateDomainIncidentList = (dispatch: TypedDispatch) => {
    dispatch(domainIncidentAPI.util.invalidateTags(['DomainIncident', 'SummaryDomainIncident']));
};

export const useDomainMonitorDelete = ({item, handleClose}: IMutationParams) => {
    const [deleteDomainMonitor, {isLoading}] = domainMonitorAPI.useDeleteDomainMonitorMutation();

    return useMonitorDelete({
        request: () => deleteDomainMonitor(item.uuid).unwrap(),
        isLoading,
        handleClose,
        successText: getMonitorLifecycleTexts().deleted,
        listUrl: AppUrls.DOMAIN_MONITORS,
        detailsRoute: AppUrls.DOMAIN_MONITOR_DETAILS,
        withTags: true,
        onDeleted: invalidateDomainIncidentList,
    });
};
